/*-- import aliases -----------
'!/...' -> project root
'~/...' -> js folder root
-----------------------------*/
import { setup } from "~/core";
setup();

// import "~/global/_body";
// import "~/global/_header";
// import "~/global/_footer";
import "~/global/_siteModals";
import "~/global/_siteSearch.js";
import "~/global/_splide.js";

import "~/components/_masonryGrid.js";
import "~/components/_accordion";
import "~/components/_plantSearchResults";
import "~/components/_interiorVideoRail";
import "~/components/_eventCalendarWidget";
// import "~/components/_forms";